export const HOME_RECOMMENDATION_COUNT = 6;
export const HOME_ROTATION_MS = 3 * 60 * 60 * 1000;
/** Screen-wide cap: at most one private-seller car, paid/manual picks included. */
export const HOME_MAX_PRIVATE_LISTINGS = 1;

type Candidate = {
  id: string;
  status?: string;
  category_code?: string;
  country_code?: string;
  user_id?: string | null;
  seller_type?: string | null;
};

export const homeRotationSlot = (now = Date.now()) => Math.floor(now / HOME_ROTATION_MS);

/** Fill only unused places; never grant promotion or discard paid/manual rows. */
export function completeHomeRecommendations<P extends Candidate, F extends Candidate>(
  priority: P[], pool: F[], country: string, slot: number,
): (P | (F & { recommendationOnly: boolean }))[] {
  const seen = new Set(priority.map((row) => row.id));
  const candidates = pool.filter((row) => {
    if (seen.has(row.id) || row.status !== 'active' ||
      !['cars', 'suv'].includes(row.category_code || '') || row.country_code !== country) return false;
    seen.add(row.id);
    return true;
  }).sort((a, b) => a.id.localeCompare(b.id));
  // Stable pool traversal gives each candidate a turn rather than random repeats.
  const start = candidates.length ? slot % candidates.length : 0;
  const rotated = [...candidates.slice(start), ...candidates.slice(0, start)];
  const needed = Math.max(0, HOME_RECOMMENDATION_COUNT - priority.length);
  // A paid or manually promoted private car already uses the single private slot.
  let privateLeft = Math.max(0,
    HOME_MAX_PRIVATE_LISTINGS - priority.filter((row) => row.seller_type === 'private').length);
  const fillers: F[] = [];
  for (const row of rotated) {
    if (fillers.length >= needed) break;
    if (row.seller_type === 'private') {
      if (privateLeft <= 0) continue;
      privateLeft -= 1;
    }
    fillers.push(row);
  }
  return [...priority, ...fillers.map((row) => ({ ...row, recommendationOnly: true }))];
}
